import { useEffect, useRef } from "react";
import { useDeployService } from "@api/deploys.hooks";
import { Deploy } from "@shared";

const HEARTBEAT_INTERVAL_MS = 60_000;
const TERMINAL_STATUSES = Deploy.TERMINAL_DEPLOY_STATUSES as readonly string[];

/**
 * Sends periodic heartbeats to keep the deploy alive.
 * The orchestrator cancels deploys where user_active_at > 5 minutes ago.
 */
export function useDeployHeartbeat(
  deployId: number | undefined,
  deployStatus: string | undefined
) {
  const service = useDeployService();
  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  useEffect(() => {
    if (!deployId || (deployStatus && TERMINAL_STATUSES.includes(deployStatus))) {
      return;
    }

    // Touch immediately on mount
    service.touch(deployId).catch(() => {});

    intervalRef.current = setInterval(() => {
      service.touch(deployId).catch(() => {});
    }, HEARTBEAT_INTERVAL_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [deployId, deployStatus, service]);
}
